import Const from 'Utils/Consts'

const CommonApiPaths = {
  Translation: {
    GetAll: `digital_software_management/api/ParrotTranslation/GetAll?SoftwareCode=${Const.env.REACT_APP_REACT_SOFT_WARE_CODE}`,
    GetAllJson: 'software_management/api/ParrotTranslation/GetAllJson',
  },
  Expert: {
    GetInsuranceExpertFieldsCurrentUser:
      'registration_issurance_visit/api/Expert/GetInsuranceExpertFieldsCurrentUser',
    SetSsoData: 'registration_issurance_visit/api/Expert/SetSsoData',
  },
  HealthCheck: 'registration_issurance_visit/health',
  settings: {
    GetAllSettings: `software_management/api/DipConfiguration/GetConfigsByAppKey?ApplicationKey=${Const.env.REACT_APP_APPLICATION_KEY}`,
  },
  users: {
    GetUserAccessList: `digital_software_management/api/DipUserRole/GetAllUserSoftwarePartsForPod?SoftwareCode=${Const.env.REACT_APP_REACT_SOFT_WARE_CODE}`,
  },
  Tts: {
    GenerateAudio: `text-to-speech/v1/audio/speech`,
    RIVTextToSpeech: `registration_issurance_visit/api/TTS/RIVTextToSpeech`,
  },
}

export default CommonApiPaths
